// extracted by css-extract-rspack-plugin
export default {"chipsRow":"StickyHeaderChips-module__chipsRow__ooHW2"};